<template>
  <div>
    <h4>
      {{$t('printers.modal.workgroupAccess.desc')}}
    </h4>
    <p>
      {{$t('printers.modal.workgroupAccess.noCodeDesc')}}
    </p>
    <br />
    <div>
      <label>{{$t('printers.modal.workgroupAccess.accessCode')}}</label>
      <b-input type="text" v-model="code" class="inp"></b-input>
    </div>
    <br />
    <br />
    <p class="text-info" v-html="$t('printers.modal.workgroupAccess.notJoinedEducationalProgram', {quoteLink: 'https://www.3dprinteros.com/quote/'})"></p>
  </div>
</template>

<script>
  import {mapActions} from "vuex";

  export default {
    name: 'workgroup-access',
    data() {
      return {
        code: ''
      }
    },
    methods: {
      ...mapActions(['connectToWorkgroup']),

      handleEnterAccessCode() {
        this.connectToWorkgroup(this.code).then(({data}) => {
          if (!data.result) {
            this.msgBoxOk(data.message);
          }
        });
      }
    }
  }
</script>